import React, { useState, useEffect, useRef, forwardRef } from 'react';
import '../styles/topHeader.css';
import githubLogo from '../images/GitHub_Invertocat_Logo.png';
import linkedInLogo from '../images/linkedinLogo.png';

function TopHeader({ scrollToRef, section1, section2, section3, section4, section5, section6 }) {
  const vhToPixels = (vh) => vh * document.documentElement.clientHeight / 100;

  const scrollToVh = (vh) => {
    window.scrollTo({
      top: vhToPixels(vh),
      behavior: 'smooth',
    });
  };

  return(
     <div className="button-container sticky-header">
      <div className="button-group left">
        <button className="text-button" onClick={() => scrollToVh(0)}>INTRO</button>
        <button className="text-button" onClick={() => scrollToVh(110)}>PROJECTS</button>
        <button className="text-button" onClick={() => scrollToVh(380)}>EXPERIENCE</button>
      </div>
      <div className="button-group right">
        <button className="text-button" onClick={() => scrollToVh(615)}>INFO</button>
        <button className="text-button" onClick={() => scrollToVh(615)}>EDUCATION</button>
        <button className="text-button" onClick={() => scrollToVh(700)}>CONTACT</button>
      </div>
      <a href='https://github.com/taaare' className='image-link'>
        <img alt='GitHub' src={githubLogo} className='social-icon github'/>
      </a>
      <a href='https://www.linkedin.com/in/adamsanfacon/' className='image-link'>
        <img alt='LinkedIn' src={linkedInLogo} className='social-icon linked-in'/>
      </a>
    </div>
  );
}

export default TopHeader;
